import axios from 'axios';
import { apiUrl } from './index';
import { setCsrfToken } from '@/core/axios';

// Kept off the shared instance so the refresh never waits on its own refresh
// gate. It needs no Authorization header (the backend reads refresh_token from
// the body) and no CSRF token (api/auth/* is exempt), but the response still
// carries a fresh X-CSRF-Token, captured manually below since the shared
// response interceptor does not run here.
//
// The timeout is not a nicety. A refresh that never settles hangs every request
// behind the gate in core/axios, and leaves the cycle active so nothing can
// start a second one to rescue it — the whole app stops, silently and with no
// error anywhere. Bounding the call turns that into a normal failure.
export const refreshAxios = axios.create({ timeout: 15000 });

export default {
  login(userAuth) {
    return axios({
      method: 'post',
      url: `${apiUrl}/auth/login`,
      data: userAuth,
    });
  },
  logout() {
    return axios({
      method: 'post',
      url: `${apiUrl}/auth/logout`,
    });
  },
  getUserPermissions(query) {
    return axios({
      method: 'get',
      url: `${apiUrl}/permissions/${query.country}`,
    });
  },
  refreshToken({ refresh_token }) {
    return refreshAxios({
      method: 'post',
      url: `${apiUrl}/auth/refresh`,
      data: {
        refresh_token,
      },
    }).then((res) => {
      setCsrfToken(res.headers);

      return res;
    });
  },
  register(user) {
    return axios({
      method: 'post',
      url: `${apiUrl}/register/new/${user.token}`,
      data: {
        ...user,
      },
    });
  },
  registerInvited(user) {
    return axios({
      method: 'post',
      url: `${apiUrl}/register/invited`,
      data: user,
    });
  },
  confirmBusiness(userDetails) {
    return axios({
      method: 'post',
      url: `${apiUrl}/register/first`,
      data: userDetails,
    });
  },
  isValidRegistrationToken(token) {
    return axios({
      method: 'post',
      url: `${apiUrl}/register/second/${token}`,
      data: {
        token,
      },
    });
  },
  isValidInvitationToken(token) {
    return axios({
      method: 'get',
      url: `${apiUrl}/register/invited/${token}`,
      params: {
        token,
      },
    });
  },
  isValidPassResetToken(token, email) {
    const params = {
      token,
      email_encrypted: email,
    };

    return axios({
      method: 'get',
      url: `${apiUrl}/password/reset`,
      params,
    });
  },
  isValidPassSetToken(token) {
    const params = {
      token,
    };

    return axios({
      method: 'get',
      url: `${apiUrl}/password/request/${token}`,
      params,
    });
  },
  sendPassResetRequest(email, recaptcha = '') {
    return axios({
      method: 'post',
      url: `${apiUrl}/password/email`,
      data: {
        email,
        'g-recaptcha-response': recaptcha,
      },
    });
  },
  resetPass(token, email, password, recaptcha = '') {
    return axios({
      method: 'post',
      url: `${apiUrl}/password/reset`,
      data: {
        token,
        email,
        password,
        'g-recaptcha-response': recaptcha,
      },
    });
  },
  setPass(token, email, password) {
    return axios({
      method: 'post',
      url: `${apiUrl}/password/set/${token}`,
      data: {
        token,
        email,
        password,
      },
    });
  },
};
